import { Link } from 'react-router';
import { Button } from '../components/ui/button';
import LayoutGuest from '../components/layouts/LayoutGuest';

export default function NotFoundPage() {
  return (
    <LayoutGuest>
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center p-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-4 animate-fade-in-down">404 - Page Not Found</h1>
          <p className="text-gray-600 mb-6 animate-fade-in-up">The page you are looking for does not exist.</p>
          <Link to="/">
            <Button type="button">Go Back Home</Button>
          </Link>
        </div>
      </div>
    </LayoutGuest>
  );
}
